import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConfirmDialogComponent} from "../../../../common/dialogs/confirm-dialag/confirm-dialag.component";
import {MatDialog} from "@angular/material";

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  /**
   * the following parameters are needed to create your own styled "edit" button
   * editIconClass - icon
   * editBtnClass - button styles
   * editTitle - button title
   * editLabel = button label
   *
   * And "delete" button has the same parameters
   */
  @Input()
  editIconClass: string = 'ti-pencil';
  @Input()
  editBtnClass: string = 'btn btn-primary btn-sm';
  @Input()
  editTitle: string = 'button for edit';
  @Input()
  editLabel: string;

  @Output() onEditBtnClick = new EventEmitter<any>();


  @Input()
  delIconClass: string = 'ti-trash';
  @Input()
  delBtnClass: string = 'btn btn-danger btn-sm';
  @Input()
  delTitle: string = 'button for delete';
  @Input()
  delLabel: string;

  //todo deletion after confirmation is doesn't work|by Dimash
  @Input() deleteAfterConfirm: boolean;

  @Output() onDeleteBtnClick = new EventEmitter<any>();

  constructor(private _dialog: MatDialog) {
  }

  ngOnInit() {
  }

  editEvent(event) {
    this.onEditBtnClick.emit(event);
  }

  deleteEvent(event) {
    this.onDeleteBtnClick.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/button/button.component.ts